export default __webpack_public_path__ + "static/media/OpenSans-Bold.b87be75f.woff2";